import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  adminImage:string=''
  firstName:string=''
  lastName:string=''
  baseUrl=environment.apiURL;
  constructor(private http: HttpClient) { }

  updateAdminPassword(data:any):Observable<object>{
    return this.http.post(this.baseUrl+'auth/changePassword',data)
  }

}
